"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const common_utils_1 = require("@zapier/common-utils");
const ChoiceItemContainer_1 = __importDefault(require("./ChoiceItemContainer"));
const CustomMapperStyles_1 = __importDefault(require("./CustomMapperStyles"));
const emptyItemsContainerCss = {
    padding: `${theme_1.Spacing.medium}px ${theme_1.Spacing.small}px`,
};
const fallbackTextCss = {
    fontWeight: 700,
};
const ChoiceItemsContainer = ({ items, onSelect, fallback, onUseFallback, }) => (common_utils_1.isolateComponent("div", { css: CustomMapperStyles_1.default.choiceItemsContainer },
    items.map(item => (common_utils_1.isolateComponent(ChoiceItemContainer_1.default, { item: item, key: item.value, onSelect: onSelect }))),
    lodash_1.isEmpty(items) && (common_utils_1.isolateComponent("div", { css: emptyItemsContainerCss },
        common_utils_1.isolateComponent(design_system_1.Text, { color: "grey500" }, "No matches found."),
        fallback && (common_utils_1.isolateComponent(design_system_1.Text, null,
            "\u00A0",
            common_utils_1.isolateComponent(design_system_1.Link, { onClick: () => onUseFallback && onUseFallback(fallback) },
                "Use \u201C",
                common_utils_1.isolateComponent("span", { css: fallbackTextCss }, fallback),
                "\u201D")))))));
exports.default = ChoiceItemsContainer;
